import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import "../css/contact.css";
export default function Contact(){
    
    return (
<div id="contact">
<a href='https://github.com/tarakes' target="_blank"  rel="noreferrer"><GitHubIcon style={{fill:"black"}} /></a>
<a href='https://linkedin.com/in/tarakeswarmondal-810aab204'  target="_blank"  rel="noreferrer"  ><LinkedInIcon style={{fill:"blue"}}/></a>
<a href='https://www.instagram.com/mondaltarakeswar/'  target="_blank"  rel="noreferrer"><InstagramIcon style={{fill:"#8a3ab9"}} /></a>
</div>
    );
}